export const ACTIVITY_STATUSES = {
  // textColor: darker shade of color that stays readable (WCAG AA) on the
  // soft pill background. icon: the same icon the calendar draws on the block.
  scheduled: {
    label: "Scheduled",
    className: "status-scheduled",
    color: "#4d8dff",
    textColor: "#3a6abf",
    icon: null,
  },
  completed: {
    label: "Completed",
    className: "status-completed",
    color: "#2bb6a3",
    textColor: "#1d7a6d",
    icon: "bi-check-circle-fill",
  },
  postponed: {
    label: "Postponed",
    className: "status-postponed",
    color: "#e0901f",
    textColor: "#986215",
    icon: "bi-pause-circle-fill",
  },
  cancelled: {
    label: "Cancelled",
    className: "status-cancelled",
    color: "#e55353",
    textColor: "#b74242",
    icon: "bi-x-circle-fill",
  },
  tentative: {
    label: "Tentative",
    className: "status-tentative",
    color: "#f59f00",
    textColor: "#986300",
    icon: "bi-question-circle-fill",
  },
};

export function getActivityStatusMeta(status) {
  return ACTIVITY_STATUSES[status] || ACTIVITY_STATUSES.scheduled;
}

/** User-facing status — shows Tentative when flagged, even though DB status stays scheduled. */
export function getActivityDisplayStatus(activity) {
  const status = (activity && activity.status) || "scheduled";
  if (activity && activity.is_tentative && status === "scheduled") {
    return ACTIVITY_STATUSES.tentative;
  }
  return getActivityStatusMeta(status);
}

// Not a stored status: shown instead of "Scheduled" once an activity's last day
// has passed, so an ended activity never reads as upcoming.
export const ENDED_DISPLAY_STATUS = {
  label: "Ended",
  className: "status-ended",
  color: "#768192",
  textColor: "#4f5b6b",
  icon: "bi-clock-history",
};

/** True once the activity's last day is over (the rule the server uses for reports). */
export function hasActivityEnded(activity, today = new Date()) {
  const lastDay = String((activity && (activity.end_date_time || activity.start_date_time)) || "");
  const [y, m, d] = lastDay.slice(0, 10).split("-").map(Number);
  if (!y || !m || !d) return false;
  const startOfToday = new Date(today.getFullYear(), today.getMonth(), today.getDate());
  return new Date(y, m - 1, d) < startOfToday;
}

/** Plain "Scheduled" is the default, so lists can leave its pill out. */
export function isDefaultDisplayStatus(activity) {
  return getActivityDisplayStatus(activity) === ACTIVITY_STATUSES.scheduled;
}

function withAlpha(hex, alpha) {
  const n = parseInt(hex.slice(1), 16);
  return `rgba(${(n >> 16) & 255}, ${(n >> 8) & 255}, ${n & 255}, ${alpha})`;
}

/**
 * Status pills are soft (tinted background, dark text) so they never look like
 * the solid, type-colored pill beside them.
 */
export function getStatusPillStyle(meta) {
  return {
    backgroundColor: withAlpha(meta.color, 0.12),
    borderColor: withAlpha(meta.color, 0.4),
    color: meta.textColor,
  };
}

export function formatLogAction(action) {
  const labels = {
    created: "Created",
    updated: "Edited",
    completed: "Completed",
    postponed: "Postponed",
    cancelled: "Cancelled",
    rescheduled: "Rescheduled",
    confirmed: "Confirmed",
    tagged: "Tagged employees",
    report_submitted: "Activity report",
    report_assignee: "Report assigned",
  };
  return labels[action] || action;
}
